"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateBrokerDto = void 0;
const tslib_1 = require("tslib");
const swagger_1 = require("@nestjs/swagger");
const create_address_dto_1 = require("../../address/dto/create-address.dto");
const class_validator_1 = require("class-validator");
const class_transformer_1 = require("class-transformer");
const common_1 = require("@nestjs/common");
const response_utils_1 = require("../../../../../../../libs/service-lib/src/lib/utils/response.utils");
class CreateBrokerDto {
}
exports.CreateBrokerDto = CreateBrokerDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Name of the broker organization (e.g., IIRM India)",
        example: "ABC Brokers Pvt Ltd",
        maxLength: 200,
    }),
    (0, class_validator_1.IsNotEmpty)({ message: "Broker Name is required." }),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.MaxLength)(200, { message: "Broker name must not exceed 200 characters" }),
    (0, class_transformer_1.Transform)(({ value }) => (value ? value.trim() : value)),
    tslib_1.__metadata("design:type", String)
], CreateBrokerDto.prototype, "brokerName", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Display name for the broker organization",
        example: "ABC Brokers",
        maxLength: 100,
    }),
    (0, class_validator_1.IsNotEmpty)({ message: "Display name is required." }),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.MaxLength)(100, { message: "Display name must not exceed 100 characters" }),
    (0, class_transformer_1.Transform)(({ value }) => (value ? value.trim() : value)),
    tslib_1.__metadata("design:type", String)
], CreateBrokerDto.prototype, "displayName", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Type of the company (e.g., Private, Public)",
        example: 19,
    }),
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.IsNotEmpty)({ message: "company Type is required." }),
    tslib_1.__metadata("design:type", Number)
], CreateBrokerDto.prototype, "companyTypeLid", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Website URL of the broker organization",
        example: "https://www.abcbrokers.com",
        required: false,
    }),
    (0, class_validator_1.IsUrl)({}, { message: "Website must be a valid URL" }),
    (0, class_transformer_1.Transform)(({ value }) => {
        value = value ? value.trim() : value;
        return value?.length === 0 ? null : value;
    }),
    (0, class_validator_1.IsOptional)(),
    tslib_1.__metadata("design:type", String)
], CreateBrokerDto.prototype, "website", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Additional comments or details about the broker",
        example: "Leading insurance broker in the region",
        maxLength: 500,
        required: false,
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)()
    // @MaxLength(500, { message: "Remarks must not exceed 500 characters" })
    ,
    (0, class_transformer_1.Transform)(({ value }) => {
        const cleanedValue = value ? (0, response_utils_1.removeHtmlTags)(value) : value;
        if (cleanedValue && cleanedValue.length > 500) {
            throw new common_1.BadRequestException("Broker remarks must not exceed 500 characters ");
        }
        return value?.length === 0 ? null : value;
    }),
    tslib_1.__metadata("design:type", String)
], CreateBrokerDto.prototype, "remarks", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)({ message: "Status ID must be an integer." }),
    tslib_1.__metadata("design:type", Number)
], CreateBrokerDto.prototype, "statusLid", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)(),
    tslib_1.__metadata("design:type", Number)
], CreateBrokerDto.prototype, "createdBy", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)(),
    tslib_1.__metadata("design:type", Number)
], CreateBrokerDto.prototype, "updatedBy", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", typeof (_a = typeof Date !== "undefined" && Date) === "function" ? _a : Object)
], CreateBrokerDto.prototype, "createdAt", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", typeof (_b = typeof Date !== "undefined" && Date) === "function" ? _b : Object)
], CreateBrokerDto.prototype, "updatedAt", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "List of addresses associated with the broker",
        type: [create_address_dto_1.CreateAddressDto],
        required: false,
    }),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => create_address_dto_1.CreateAddressDto),
    tslib_1.__metadata("design:type", Array)
], CreateBrokerDto.prototype, "address", void 0);
